export const COL_OFFSET = 1;
